import * as React from 'react';
import { SVGProps } from 'react';

const IconDiamondSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18.75 2.75 21 8h-6l2.571-6H6L0 8l10.737 13.421L6 8h6v15L24 8l-5.25-5.25z" />
  </svg>
);
export default IconDiamondSizeM;
